<mat-card>
  <mat-card-content>
    <div class="header-wrapper">
      <div class="mat-h2">{{ title }}</div>

      <div>
        <mat-form-field floatLabel="always" appearance="outline" >
          <mat-label class="mat-label">{{
            'SEARCH.search' | translate
          }}</mat-label>
          <input
            id="search"
            #search
            matInput
            (keyup)="monitorSearch(search.value)"
            [placeholder]="'RECENT_INVITES.enter_email' | translate"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
    </div>
    @if (!loading && noRecordFound && invites?.length === 0) {
      <app-not-found
        [displayMessage]="message"
      ></app-not-found>
    }

    <table
      mat-table
      [dataSource]="invitesDataSource"
      [ngClass]="noRecordFound ? 'hide' : ''"
    >
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef width="40%">
          {{ 'RECENT_INVITES.email' | translate }}
        </th>
        <td mat-cell *matCellDef="let invite">{{ invite.email }}</td>
      </ng-container>

      <ng-container matColumnDef="dateInvited">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'RECENT_INVITES.dateInvited' | translate }}
        </th>
        <td mat-cell *matCellDef="let invite">{{ invite.dateInvited }}</td>
      </ng-container>

      <ng-container matColumnDef="companyName">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'RECENT_INVITES.companyLink' | translate }}
        </th>
        <td mat-cell *matCellDef="let invite">
          @if (invite.companyAccountId) {
            <a (click)="$event.stopPropagation(); handleNavigate(invite)">
              {{ invite.companyName }}
            </a>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
    <mat-paginator
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[10, 25, 50, 100]"
    ></mat-paginator>
  </mat-card-content>
</mat-card>
@if (loading) {
  <app-spinner></app-spinner>
}
